<template>
  <Transition name="nova-versao">
    <div
      v-if="novaVersaoDisponivel"
      class="nova-versao-aviso shadow-lg rounded-3"
      role="status"
      aria-live="polite"
    >
      <i class="ph ph-arrow-clockwise nova-versao-icone" aria-hidden="true"></i>

      <span class="nova-versao-texto">Há uma versão nova do sistema.</span>

      <button
        type="button"
        class="btn btn-sm btn-primary fw-semibold px-3"
        @click="aplicarNovaVersao()"
      >
        Atualizar
      </button>

      <button
        type="button"
        class="btn-close btn-close-white ms-1"
        aria-label="Adiar atualização"
        @click="dispensarAviso()"
      ></button>
    </div>
  </Transition>
</template>

<script setup>
import { useNovaVersao } from '@/composables/useNovaVersao.js'

const { novaVersaoDisponivel, aplicarNovaVersao, dispensarAviso } = useNovaVersao()
</script>

<style scoped>
/* Canto inferior esquerdo: o direito já é ocupado pelo botão de voltar ao topo e pelos
   botões flutuantes do formulário. */
.nova-versao-aviso {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1055;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background-color: #0b1a34;
  color: #ffffff;
  font-size: 14px;
  max-width: calc(100vw - 40px);
}

.nova-versao-icone {
  font-size: 18px;
  flex-shrink: 0;
}

.nova-versao-texto {
  margin-right: 4px;
}

.nova-versao-enter-active,
.nova-versao-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.nova-versao-enter-from,
.nova-versao-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

/* Aparecer deslizando pode tirar a atenção de quem está preenchendo um formulário */
@media (prefers-reduced-motion: reduce) {
  .nova-versao-enter-active,
  .nova-versao-leave-active {
    transition: opacity 0.25s ease;
  }

  .nova-versao-enter-from,
  .nova-versao-leave-to {
    transform: none;
  }
}
</style>
